import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  paper: {
    width: 370,
    height: 310,
  },
  paperEdit: {
    width: 630,
    height: 540,
  },
  desc: {
    margin: 0,
  },
  textFields: {
    flexGrow: 1,
  },
  textFiledGroup: {
    color: '#323232',
  },
  textFieldsGroup: {
    paddingBottom: 44,
    fontWeight: 600,
    [theme.breakpoints.down(960)]: {
      paddingBottom: theme.spacing(2),
    }
  },
  textFieldsGroupName: {
    paddingTop: 15,
  },
  textFieldsGroupColors: {
    paddingBottom: 34,
    [theme.breakpoints.down(960)]: {
      paddingBottom: theme.spacing(2),
    }
  },
  textField: {
    paddingTop: 24,
    paddingBottom: 24,
  },
  colorField: {
    width: 120,
  },
  colorFieldIcon: {
    padding: 0,
  },
  dialogActionsWrap: {
    padding: '16px 24px',
  },
  btnWrap: {
    flexBasis: '50%',
    height: 36,
    '&:not(:first-child)': {
      marginLeft: 12,
    },
    '&:not(:last-child)': {
      marginRight: 12,
    },
  },
  checkboxWhiteSpace: {
    [theme.breakpoints.down(960)]: {
      display: 'none',
    }
  },
  checkbox: {
    [theme.breakpoints.down(960)]: {
      paddingLeft: theme.spacing(1),
    }
  }
});

export default styles